export const endpoints = {
  codetableOptions: 'code/optionsCollection/options',
  userGroupOptions: 'code/usergroup/options',
  caseTypeOptions: 'code/caseType/options',
  codetablesAccess: 'optionsCollection/access',
  codetableMetadata: (codetableId: number) => `optionsCollection/${codetableId}/metadata`,
  codetableSearch: (codetableId: number) => `optionsCollection/${codetableId}/search`,
  saveActionsUserGroup: (codetableId: number, userGroupId: number) =>
    `optionsCollection/${codetableId}/userGroup/${userGroupId}:link`,
  saveActionsType: (codetableId: number, typeId: number) =>
    `optionsCollection/${codetableId}/type/${typeId}:link`
};
